/* eslint-disable react/display-name */
import React from 'react';
import styled from 'styled-components';
import { useDrop } from 'react-dnd';
import update from 'immutability-helper';

import { DraggableCard } from './styled/DraggableCard';

export const ReorderCategories = React.memo(({ categories = [], isDraggable, onChange }) => {
  const [cards, setCards] = React.useState(categories);

  const findCard = React.useCallback(
    (id) => {
      const card = cards.filter((c) => `${c.id}` === id)[0];
      return {
        card,
        index: cards.indexOf(card),
      };
    },
    [cards]
  );

  const moveCard = React.useCallback(
    (id, atIndex) => {
      const { card, index } = findCard(id);
      const updatedCards = update(cards, {
        $splice: [
          [index, 1],
          [atIndex, 0, card],
        ],
      });
      setCards(updatedCards);
      if (onChange) {
        onChange(updatedCards);
      }
    },
    [findCard, cards, setCards]
  );

  const [, drop] = useDrop(() => ({ accept: 'job-category' }));

  return (
    <Container ref={drop}>
      {cards.map((card) => (
        <DraggableCard
          key={card.id}
          id={`${card.id}`}
          text={card.name}
          type="job-category"
          isDraggable={isDraggable}
          moveCard={moveCard}
          findCard={findCard}
        />
      ))}
    </Container>
  );
});

const Container = styled.div`
  width: 100%;
`;
